import { capitalize } from 'lodash';

import type { TaskCustomField } from '@/task-manager/entities/task-custom-field';

export type TaskDataOnboardingDescriptionProps = {
  description: string | undefined;
  customFields?: TaskCustomField[];
};

export function TaskDataOnboardingDescription({
  description,
  customFields = [],
}: TaskDataOnboardingDescriptionProps) {
  return (
    <div className="flex flex-col text-sm text-neutral-700">
      <div className="mb-4 font-semibold">Description</div>
      <div className="mb-6">{description}</div>
      {customFields.length > 0 ? (
        <dl>
          {customFields.map((data) => (
            <div
              key={data.name}
              className="grid grid-cols-3 border-l-2 border-neutral-300 px-6 py-2"
            >
              <dt>{capitalize(data.name)}</dt>
              <dd className="col-span-2">{formatValue(data)}</dd>
            </div>
          ))}
        </dl>
      ) : null}
    </div>
  );
}

function formatValue({ value }: TaskCustomField) {
  if (Array.isArray(value)) {
    return value.join(', ');
  }

  if (typeof value === 'object') {
    return JSON.stringify(value, null, 2);
  }

  if (typeof value === 'boolean') {
    return capitalize(String(value));
  }

  return String(value);
}
